import { MilestoneRoleField } from "@/containers/Project/components/Milestones/components/MilestoneRoleField";
import { FieldNames, FormType } from "@/enums/";
import { projectMilestoneRole } from "@/propTypes";
import {
  useFormPropertyValueLookupProvider,
  useProjectContext,
} from "@/providers";
import { Typography } from "antd";
import _ from "lodash";
import { arrayOf, bool, object } from "prop-types";
import { Fragment, useEffect, useState } from "react";

const { Title } = Typography;

export const MilestoneRoleDisplay = ({ roles, form, editMode }) => {
  const { getPropertyValueDisplay } = useFormPropertyValueLookupProvider();
  const { templateRolesMap, templateRolesMapLoading } = useProjectContext();
  const [disabledRoles, setDisabledRoles] = useState({});
  const [displayRoles, setDisplayRoles] = useState({});

  useEffect(() => {
    setDisplayRoles(roles || []);
    setDisabledRoles(
      _.mapValues(
        _.keyBy(roles, (role) => role.id),
        (role) => !editMode || !!role.isNotApplicable
      )
    );
  }, [editMode, roles]);

  const handleToggle = (event, key) => {
    if (event.target.checked) {
      form.setFieldsValue({
        [key]: { assignedUsers: [], isNotApplicable: event.target.checked },
      });
    } else {
      const role = roles.find((x) => x.id === key);
      if (role.limitedList && role.availableUsers?.length === 1) {
        form.setFieldsValue({
          [key]: {
            assignedUsers: [role.availableUsers[0].userId],
            isNotApplicable: event.target.checked,
          },
        });
      }
    }

    setDisabledRoles((prevState) => ({
      ...prevState,
      [key]: event.target.checked,
    }));
  };

  if (!roles?.length) {
    return null;
  }

  const renderRolesByFunctionalArea = () => {
    const rolesGroupByFunctionalArea = _.groupBy(
      displayRoles,
      (x) => x.functionalAreaId
    );
    return Object.keys(rolesGroupByFunctionalArea).map((functionalAreaId) => (
      <Fragment key={functionalAreaId}>
        <Title level={5}>
          {getPropertyValueDisplay(
            FormType.Intake,
            FieldNames.FunctionalArea,
            functionalAreaId
          )}
        </Title>
        {rolesGroupByFunctionalArea[functionalAreaId].map((role) => (
          <MilestoneRoleField
            key={`project-milestone-role-${role.id}`}
            role={role}
            editMode={editMode}
            disabledRoles={disabledRoles}
            handleToggle={handleToggle}
            templateRolesMap={templateRolesMap}
          />
        ))}
      </Fragment>
    ));
  };

  if (!templateRolesMapLoading && templateRolesMap) {
    return <>{renderRolesByFunctionalArea()}</>;
  }
};

MilestoneRoleDisplay.propTypes = {
  roles: arrayOf(projectMilestoneRole),
  form: object,
  editMode: bool.isRequired,
};
